export class AdsCampaignArea {
    id!: number
    city!: string
    radius!: number
    lat!: number
    long!: number
}
